import { useContext } from 'react';
import { AssistantContext, type AssistantContextValue } from './AssistantProvider';

/** Access the one shared conversation. Throws outside the provider rather than handing back
 *  a null the caller would have to defend against on every field. */
export function useAssistant(): AssistantContextValue {
  const ctx = useContext(AssistantContext);
  if (!ctx) throw new Error('useAssistant must be used within an AssistantProvider');
  return ctx;
}
